/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.branding.rpc.BrandingDataRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getAllBrandingDataRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingDataRpc',
  rpcName: 'getAllBrandingData',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAGaKYlO9QdW5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOrDefaultRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandingDataRpc',
  rpcName: 'getOrDefault',
  auth: 'app',
  fingerprint: 'tJg3nIYuj94JAXg5uGxQwJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};